import React, { useCallback, useEffect, useState } from 'react';
import style from './index.scss';
import GameItem from '../../../Details/Games/GameItem';
import classNames from '../../../Details/classNames';
import { usePortletTranslations } from '../../../../../system/Portlet';

let portraitCount = 6;
let landscapeCount = 8;

const VerticalGamesView = (props) => {
    const { gameCodes, deviceSelector, isShowPlayButtonOnHover, trackChangeGameClick, isInMissionsItemCard,
        updateCardHeight, imageMission, urlMission, missionStatus } = props;
    const t = usePortletTranslations();
    const { isLandscape, isMobile, isTablet, isDesktop } = deviceSelector;

    const getCount = useCallback(() => {
        if (isInMissionsItemCard) {
            return portraitCount;
        }
        return isLandscape || isDesktop || isTablet ? landscapeCount : portraitCount;
    }, [isLandscape, isDesktop, isTablet, isInMissionsItemCard]);

    const getGamesToShow = useCallback((countGames) => {
        return gameCodes.slice(0, countGames);
    }, [gameCodes]);

    const resizeHandler = useCallback(() => {
        if (isDesktop) {
            setIsDesktopSmallWidth(window.innerWidth < 475);
        }
    }, [isDesktop]);

    const [games, setGames] = useState([]);
    const [isDesktopSmallWidth, setIsDesktopSmallWidth] = useState(window.innerWidth < 475);

    useEffect(() => {
        setGames(getGamesToShow(getCount()));
    }, [gameCodes, getGamesToShow, getCount, imageMission]);

    useEffect(() => {
        return () => {
            if (!isInMissionsItemCard) {
                portraitCount = 6;
                landscapeCount = 8;
            }
        };
    }, [isInMissionsItemCard]);

    useEffect(() => {
        window.addEventListener('resize', resizeHandler);
        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, [resizeHandler]);

    const onClickLoadMore = () => {
        landscapeCount += 8;
        portraitCount += 6;
        setGames(getGamesToShow(getCount()));
        if (updateCardHeight) {
            setTimeout(() => { updateCardHeight(); }, 0);
        }
    };

    const isShowedAllGames = () => {
        return isInMissionsItemCard ? games.length === gameCodes.length || games.length < portraitCount
            : games.length === gameCodes.length;
    };

    const isMissionCardNoGames = () => {
        let gamesIsPresent = false;
        gameCodes.forEach((gameObjectInfo) => {
            if (Object.keys(gameObjectInfo).length !== 0) {
                gamesIsPresent = true;
            }
        });
        return isInMissionsItemCard && !gamesIsPresent;
    };

    return <div className={classNames(style.wrapper, { [style.missionsWrapper]: isInMissionsItemCard })}>
        <div className={classNames(style.games, { [style.missionsGames]: isInMissionsItemCard })}>
            { isMissionCardNoGames() ?
                <GameItem className={classNames(style.gameItemStyle,
                              { [style.gameItemStyleLandscape]: isMobile && isLandscape && !isInMissionsItemCard
                                  || isTablet && !isInMissionsItemCard
                                  || isDesktop && !isDesktopSmallWidth && !isInMissionsItemCard })}
                          imageClassName={style.gameImageStyle}
                          showGameInfo={true}
                          showFeatureIcons={false}
                          isShowPlayButtonOnHover={isShowPlayButtonOnHover}
                          trackChangeGameClick={trackChangeGameClick}
                          isInMissionsItemCard={isInMissionsItemCard}
                          missionNoGamesImage={imageMission}
                          urlMission={urlMission}
                          isGameIsNotEarnPoints={missionStatus !== 'active'}
                />
                : games.map((gameObj) => {
                return <GameItem key={gameObj.gameCode}
                                 code={gameObj.gameCode}
                                 isGameIsNotEarnPoints={isInMissionsItemCard ? missionStatus !== 'active' : gameObj.isNotStarted}
                                 isGameFromEndedRule={gameObj.isFinished}
                                 timeToStartEarnPoints={gameObj.timeToStart}
                                 className={classNames(style.gameItemStyle,
                                     { [style.gameItemStyleLandscape]: isMobile && isLandscape && !isInMissionsItemCard
                                         || isTablet && !isInMissionsItemCard
                                         || isDesktop && !isDesktopSmallWidth && !isInMissionsItemCard })}
                                 imageClassName={style.gameImageStyle}
                                 showGameInfo={true}
                                 showFeatureIcons={false}
                                 isShowPlayButtonOnHover={isShowPlayButtonOnHover}
                                 trackChangeGameClick={trackChangeGameClick}
                                 gameIndexInArray={games.indexOf(gameObj) + 1}
                                 isInMissionsItemCard={isInMissionsItemCard}
                />;
                }
            )}
        </div>
        {isShowedAllGames() ? <></> : <div className={style.loadMoreWrapper}>
            <button
                className={style.loadMoreButton}
                onClick={onClickLoadMore}>
                {t('loadMore')}
            </button>
        </div>}
    </div>;
};

export default VerticalGamesView;
